import { DestroyRef, Injectable, inject, signal } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class MediaQueryService {
	private _destroyRef = inject(DestroyRef);

	createMatchSignal(query: string, initialValue = false): ReturnType<typeof signal<boolean>> {
		const mediaQuery = window.matchMedia(query);
		const matchSignal = signal(mediaQuery.matches || initialValue);

		const handler = (event: MediaQueryListEvent): void => {
			matchSignal.set(event.matches);
		};

		mediaQuery.addEventListener('change', handler);
		this._destroyRef.onDestroy(() => {
			mediaQuery.removeEventListener('change', handler);
		});

		return matchSignal;
	}
}
